import React from "react";

function LocationSection() {
  return (
    <section className="contact-con position-relative">
      <div className="container">

        {/* Heading */}
        <div className="row">
          <div className="col-12">
            <div className="contact_content text-center">
              <h2>
                Get in <span>Touch</span> With US
              </h2>
              <p>
                Reach out and connect with us today for any inquiries or assistance!
              </p>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="row">

          {/* LEFT SIDE - INFO */}
          <div className="col-lg-12">
            <div className="contact_info">
              <div className="row">

                {/* Location */}
                <div className="col-lg-4 col-md-6 col-12">
                  <div className="contact-box">
                    <figure className="icon mb-0">
                      <img
                        src="./assets/images/contact-icon1.png"
                        alt="location"
                        className="img-fluid"
                      />
                    </figure>
                    <div className="content">
                      <h6>Jubilee HillS</h6>
                      <a
                        href="https://maps.app.goo.gl/rfo7DosRqHxZPBhE7"
                        className="text-decoration-none text-size-16 mb-0" target="_blank"
                      >
                        Mohans Plaza, 733, <br />
                        Next To Madhapur Metro Station, Road No. 36, 
                        Jubilee Hills, Hyderabad, Telangana - 500033
                      </a>
                    </div>
                  </div>
                </div>


                {/* Location */}
                <div className="col-lg-4 col-md-6 col-12">
                  <div className="contact-box">
                    <figure className="icon mb-0">
                      <img
                        src="./assets/images/contact-icon1.png"
                        alt="location"
                        className="img-fluid"
                      />
                    </figure>
                    <div className="content">
                      <h6>Jubilee HillS</h6>
                      <a
                        href="https://maps.app.goo.gl/oxRqKNJ8Ls29Lbaz7?g_st=aw"
                        className="text-decoration-none text-size-16 mb-0" target="_blank"
                      >
                        Plot No 1354, <br />Opposite KBR Park <br />Gate No. 5, Road No 1 & 68, Jubileehills-500033
                      </a>
                    </div>
                  </div>
                </div>


                {/* Location */}
                <div className="col-lg-4 col-md-6 col-12">
                  <div className="contact-box">
                    <figure className="icon mb-0">
                      <img
                        src="./assets/images/contact-icon1.png"
                        alt="location"
                        className="img-fluid"
                      />
                    </figure>
                    <div className="content">
                      <h6>Vijayawada</h6>
                      <a
                        href="https://maps.app.goo.gl/RUM83bDSkGFs7M5e6?g_st=iw"
                        className="text-decoration-none text-size-16 mb-0" target="_blank"
                      >
                        Ice Cream Palace, GM49+R3P, <br />Rd Number 7, Bharathi Nagar, 
                        Vijayawada, Andhra Pradesh - 520008
                      </a>
                    </div>
                  </div>
                </div>

                
                

              </div>
            </div>
          </div>


          
         

        </div>
      </div>
    </section>
  );
}

export default LocationSection;